// coerce a null value to undefined.  This might be useful if you have nullable graph values that
// you want to pass as props which are optional.
export const notNull = <T>(value: T | null | undefined): T | undefined => (value === null ? undefined : value);
